/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers'
import React from 'react'
import ToggleLabels from 'DesignSystem/ToggleLabels/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/DefaultPaymentPlans/AddRuleset/DefaultPaymentPlans/Content/DefaultPaymentPlan/Discounts/Discount/Type",
  textNo = "$"
  
}) {
let discountTypeValueData = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'type',
})
let constantData = 'amount'
let aggregateData = fromAggregate.equals(discountTypeValueData, constantData)
let discountTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'type',
})
let constantData1 = 'percentage'
let aggregateData1 = fromAggregate.equals(discountTypeValueData1, constantData1)
let onClickNo = fromHelpers.useOnClickNo({
  children,
  viewPath,
  textNo
  
})
let onClickYes = fromHelpers.useOnClickYes({
  children,
  viewPath,
  textNo
  
})
  return (<React.Fragment
>
<ToggleLabels
  viewPath={`${viewPath}/ToggleLabels`}
 paddingTop={10}
 paddingBottom={10}
 data="discount.type"
 data="'amount'"
 aggregate="/Data/aggregate.js equals"
 isSelectedNo={aggregateData}
 onClickNo={onClickNo}
 textNo={textNo}
 data="discount.type"
 data="'percentage'"
 aggregate="/Data/aggregate.js equals"
 isSelectedYes={aggregateData1}
 onClickYes={onClickYes}
 textYes="%"
/>
{children}
</React.Fragment>)
}